import { getCustomSettings, getDDListValues, updateCustomSettings } from "../config/apiConfig";
import { getCurrencyInfo } from "../config/apiConfig";
import axios from "axios";
import { sbaAxios } from "./utils/sbaAxios";


export const getDDvalues = async () => {
    try {
      const response = await axios.get(getDDListValues);
      return response.data;
    } catch (error) {
      throw error;
    }
  };


  export const GetCurrencyInfo = async () => {
    try {
      const response = await axios.get(getCurrencyInfo);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  

/*
const getMethodInComponent = async () => {
        try {
          const data = await GetCurrencyInfo();
          setState(data);
        } catch (error) {
          console.error('Error:', error);
        }
      };
*/   

export const updateEntity=(entityType,entityId)=>{
  const previousEntity= JSON.parse(localStorage.getItem("Entities"));
  previousEntity[entityType]=entityId;
  localStorage.setItem("Entities",JSON.stringify(previousEntity));
  const Entity = Object.entries(previousEntity).map(([SettingName, Value]) => {
    return { SettingName, Value };
  });
  const saveData={
    "componentId": 1006,
    "componentUserSettingId": 0,
    "userId": 0,
    "customSettingsValue": JSON.stringify(Entity),
    "isGrid": false
  };
  sbaAxios({url:updateCustomSettings,method:'post',data:saveData}).then(response=>{}).catch(error=>{
    console.log(error,'error posting data in custom settings');
  });

};
export const getDefaultEntities=()=>{
  sbaAxios({url: `${getCustomSettings}1006`}).then(response=>{
      const defaultIds=JSON.parse(response.CustomSettingsValue);
      const transformedObject = defaultIds.reduce((result, item) => {
          result[item.SettingName] = item.Value;
          return result;
        }, {});
      localStorage.setItem("Entities",JSON.stringify(transformedObject));
  }).catch(error=>{
      console.log(error,'error fetching the data for default entities')
  })
};






